export function filterByPropertyValue(collection, propertyName, propertyValue, comparePropertyValue) {

  const collectionCount = collection.length;
  const filteredCollection = [];

  for (let index = 0; index < collectionCount; index++) {

    const object = collection[index];

    if (comparePropertyValue(object[propertyName], propertyValue, object) === true) {
      filteredCollection.push(object);
    }

  }

  return filteredCollection;

}

export function filterByPropertyValueBasic(collection, propertyName, propertyValue) {

  const collectionCount = collection.length;
  const filteredCollection = [];

  for (let index = 0; index < collectionCount; index++) {

    const object = collection[index];

    if (object[propertyName] !== propertyValue) {
      continue;
    }

    filteredCollection.push(object);

  }

  return filteredCollection;

}

function isEqual(label, searchString) {

  return label
    .toLowerCase()
    .includes(searchString.toLowerCase());

}

export function filterByPropertyPartialValue(collection, propertyName, propertyValue) {

  return filterByPropertyValue(collection, propertyName, propertyValue, isEqual);

}

function defaultCompareFunction(object, objectValue, expectedValue) {
  return objectValue === expectedValue;
}

export function getIndicesByPropertyValue(collection, propertyName, propertyValue, compareFunction = defaultCompareFunction) {

  const collectionCount = collection.length;
  const filteredIndices = [];

  for (let index = 0; index < collectionCount; index++) {

    const object = collection[index];

    if (compareFunction(object, object[propertyName], propertyValue) === true) {
      filteredIndices.push(index);
    }

  }

  return filteredIndices;

}

export function getIndicesByPropertyValues(collection, propertyName, propertyValues) {

  const collectionCount = collection.length;
  const filteredIndices = [];

  for (let index = 0; index < collectionCount; index++) {

    const object = collection[index];

    if (propertyValues.indexOf(object[propertyName]) !== -1) {
      filteredIndices.push(index);
    }

  }

  return filteredIndices;

}

export function differenceByProperty(collectionA, collectionB, propertyName) {

  const difference = [];

  for (let objectA of collectionA) {

    let exists = false;

    for (let objectB of collectionB) {

      if (objectA[propertyName] === objectB[propertyName]) {
        exists = true;
        break;
      }

    }

    if (exists === false) {
      difference.push(objectA);
    }

  }

  return difference;

}

export function filterByPropertyValues(collection, propertyName, propertyValues) {

  const filtered = [];

  for (let object of collection) {

    const propertyValue = object[propertyName];

    if (propertyValues.indexOf(propertyValue) === -1) {
      continue;
    }

    filtered.push({ ...object });

  }

  return filtered;

}

export function filterByPropertyValuesInverse(collection, propertyName, propertyValues) {

  const filtered = [];

  for (let object of collection) {

    const propertyValue = object[propertyName];

    if (propertyValues.indexOf(propertyValue) !== -1) {
      continue;
    }

    filtered.push({ ...object });

  }

  return filtered;

}

export function isPropertyValueExists(collection, propertyName, value) {

  for (let object of collection) {

    const propertyValue = object[propertyName];

    if (propertyValue !== value) {
      continue;
    }

    return true;

  }

  return false;

}

export function getObjectByPropertyValue(collection, propertyName, value) {

  for (let object of collection) {

    const propertyValue = object[propertyName];

    if (value === propertyValue) {
      return object;
    }

  }

  return null;

}

export function getPropertyValues(collection, propertyName) {

  const values = [];

  for (let object of collection) {
    values.push(object[propertyName]);
  }

  return values;

}

export function findIndex(collection, compareFunction) {

  const length = collection.length;

  for (let index = 0; index < length; index++) {

    const object = collection[index];

    if (compareFunction(object) === true) {
      return index;
    }

  }

  return -1;

}

export function findIndexByPropertyValue(collection, propertyName, propertyValue) {

  const length = collection.length;

  for (let index = 0; index < length; index++) {

    const object = collection[index];

    if (object[propertyName] === propertyValue) {
      return index;
    }

  }

  return -1;

}

export function findByPropertyValue(collection, propertyName, propertyValue) {

  const index = findIndexByPropertyValue(collection, propertyName, propertyValue);

  if (index === -1) {
    return null;
  }

  return collection[index];

}

export function findById(collection, _id) {

  const index = findIndexByPropertyValue(collection, '_id', _id);

  if (index === -1) {
    throw new Error(`_id: ${_id} not found`);
  }

  return collection[index];

}

export function cloneUser(user) {

  return {
    ...user,
    profilePicture: {
      ...user.profilePicture
    }
  };

}

export function cloneUsers(users) {

  const _users = [];

  for (let user of users) {

    _users.push(cloneUser(user));

  }

  return _users;

}

export function toMap(collection, property) {

  const map = {};

  for (let object of collection) {

    const value = object[property];

    map[value] = object;

  }

  return map;

}

function defaultLabelBuilder(object, labelProperty) {
  return object[labelProperty];
}

export function convertToOption(object, labelProperty, valueProperty) {

  const options = convertToOptionsCollection([object], labelProperty, valueProperty);

  return options[0];

}

export function convertToOptionsCollection(collection, labelProperty, valueProperty, labelBuilder = defaultLabelBuilder) {

  const optionsCollection = [];
  const optionsCollectionCount = collection.length;

  for (let index = 0; index < optionsCollectionCount; index++) {

    const object = collection[index];
    const option = {
      label: labelBuilder(object, labelProperty),
      value: object[valueProperty],
      _id: object._id,
      object
    };

    optionsCollection.push(option);

  }

  return optionsCollection;

}

export function setPropertyValue(collection, propertyName, propertyValue) {

  for (let object of collection) {

    object[propertyName] = propertyValue;

  }

  return collection;

}

export function toUnique(collection, serializer = JSON.stringify) {

  const unique = [];
  const uniqueMap = {};

  for (let object of collection) {

    const serialized = serializer(object);

    if (uniqueMap[serialized] === true) {
      continue;
    }

    uniqueMap[serialized] = true;
    unique.push(object);

  }

  return unique;

}